import React from "react";
import Validate from "../../common/Validate";
import Type from "../../common/Type";
import Convert from "../../common/Convert";
import {parent_type,type} from '../../variables/column_map';
import ReactDOM from 'react-dom'
import moment from 'moment'

export default class InputBase extends React.Component {
    static defaultProps = {
        disabled:false,
        labelOn:false,
        name:'',
        className:'',
        style:{},
        enterSearchFlag: false,
        rootData:{
            values:{},
            errors:{},
            requiredData:{}
        },
        callBack:()=>{}
    }
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this)
        this.executeValidateCallback = this.executeValidateCallback.bind(this)
        this.selfDom = React.createRef()
    }

    executeValidateCallback(text, message, callBack=()=>{}){
        const{
            name,
            rootData:{
                requiredData,
                errors,
                values
            }
        } = this.props
        
        const columnObject = Convert.key_split(name)
        
        const error = message?{[columnObject.column]:message}:{}

        this.props.validateCallback({
            values:{
                ...values,
                [columnObject.column]:text
            },
            errors:{
                ...errors&&Object.keys(errors).reduce((acc, key)=>{
                    if (key!==columnObject.column){
                        acc[key]=errors[key]
                    }
                    return acc
                },{}),
                ...error
            },
            requiredData:{
                ...requiredData,
            },
        }, ()=>{callBack()});
    }

    validate(text, callBack) {
        const {
            name,
            validateType,
            label,
            rootData:{
                requiredData
            }
        } = this.props

        if ((text||text==0) && ((text.length && text.length>0)||
        Number.isInteger(text))){
            const parentTypeKey = type[name]
            const validatePreset = parentTypeKey && parent_type[parentTypeKey]
            const validateResult = validateType && validatePreset && validatePreset[validateType] && validatePreset[validateType].reduce((acc, value)=>{
                const singleValidationResult = Validate[value](acc.fixedText,label,parentTypeKey);
                const {message, valid, newText} = singleValidationResult
                acc.fixedText = newText
                if (!valid && message!=undefined){
                    acc.messageArr.push(message)
                }
                return acc
            }, {messageArr:[], fixedText:text})
            let {
                messageArr, fixedText
            } = validateResult||{messageArr:[],fixedText:text}

            this.props.validateCallback && this.executeValidateCallback(fixedText, messageArr&&(messageArr.length>0?messageArr:undefined), callBack)
        } else {
            const columnObject = Convert.key_split(name)
            const required_message = Validate.requiredCheck(requiredData, columnObject.column, label)
            this.props.validateCallback && this.executeValidateCallback(text, required_message, callBack)
        }
    }

    componentDidUpdate(prevProps){
        const name = Convert.key_split(this.props.name).column
        const table = Convert.key_split(this.props.name).table // 

        if(prevProps.rootData.values&& this.props.rootData.values&& (prevProps.rootData.values[name]!=this.props.rootData.values[name])){
            if (this.selfDom.current) {
                ReactDOM.findDOMNode(this.selfDom.current).value=this.props.rootData.values[name]
            }
        }
        else if ( table == "NOTIFICATION" ) {
            if (this.selfDom.current && this.props.rootData.values[name] != ReactDOM.findDOMNode(this.selfDom.current).value) {
                ReactDOM.findDOMNode(this.selfDom.current).value = this.props.rootData.values[name]
            }
        }
        // else if (this.props.rootData.values!=undefined && this.selfDom.current && (this.selfDom.current.value!==this.props.rootData.values[name])){
        //     ReactDOM.findDOMNode(this.selfDom.current).value=this.props.rootData.values[name]
        // }
    }
    focusNextNode(e) {
        e.preventDefault();
        let inputList = document.querySelectorAll(".tabable:not([type=hidden]):not([disabled])");
        let nextNode = null;
        for(let index = 0; index < inputList.length; index++){
            if(inputList[index].name === e.target.name){
                nextNode= inputList[index + 1];
            }
        }

        if(nextNode){
            if(!(nextNode.tagName === "INPUT" || nextNode.tagName === "TEXTAREA")){
                // react-selectの場合
                nextNode = nextNode.querySelector("input");
            } 
            nextNode.focus();
        }
    }

    trim(value){
        const parentTypeKey = type[this.props.name]
        let trimmedValue = "";

        switch(parentTypeKey){
            case "text_ja_2" :
            case "text_ja_3" :
            case "text_ja_245" :
            case "text_ja_255" :
                trimmedValue = value ? value.trim() : "";
                break;
            default :
            trimmedValue = value;
                break;
        }
        return trimmedValue;
    }
}
